module.exports = __webpack_public_path__ + "flyer_background_lake_127-d80ca5b081d8149dfa6c66c81272b283.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_lake_127.jpg
// module id = 1657
// module chunks = 1